import { render, staticRenderFns } from "./edit-info.vue?vue&type=template&id=6229ecbf"
import script from "./edit-info.vue?vue&type=script&lang=js"
export * from "./edit-info.vue?vue&type=script&lang=js"
import style0 from "./edit-info.vue?vue&type=style&index=0&id=6229ecbf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports